<style scoped="scoped" lang="scss">
.gy-html {
  margin-top: 10px;
  font-size: 12px;
  text-align: center;
  border: none !important;
}

.gy-html /deep/ table {
  border-collapse: collapse;
  border-color: rgb(232, 232, 232);
}

.gy-html /deep/ table tbody tr:first-child {
  height: 26px;
  font-size: 12px;
  background: rgb(123, 127, 128);
}

.gy-html /deep/ table tbody tr:not(:first-child) {
  height: 26px;
  font-size: 12px;
  color: #606672;
}
</style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/custom/lingpao/product/sn/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('chuangjianshijian')">
            <yi_time_input type="datetimerange" :start.sync="yt.conditions.createTimeStart" :end.sync="yt.conditions.createTimeEnd"> </yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('chanpinsn')">
            <el-input v-model="yt.conditions.productSn"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shengchangongdanhao')">
            <el-input v-model="yt.conditions.sourceWoNo"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear(conditions)">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-export" :title="$t('daochu')" @click="exportExcel" :loading="exportLoading"></el-button>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"> </el-button>
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" :loading="scope.row.getCraftParameterLoading" @click="getCraftParameter(scope.row)">
              {{ $t('chakangongyicanshu') }}
            </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>

    <!-- 工艺参数dialog -->
    <el-dialog class="dialog" :title="$t(param.title)" :visible.sync="param.visible" :width="param.width" destroy-on-close>
      <div id="export">
        <div class="gy-html" v-html="gy"></div>
      </div>
      <div slot="footer">
        <div>
          <el-button size="mini" type="default" plain @click="param.visible = false">{{ $t('quxiao') }} </el-button>
          <el-button size="mini" type="primary" @click="exportPic">{{ $t('daochutupian') }} </el-button>
          <el-button size="mini" type="primary" @click="exportPdf">{{ $t('daochupdf') }} </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

const date = new Date();
const end = new Date(date.getFullYear(), date.getMonth() + 1, 0, 23, 59, 59).getTime();
const begin = new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0).getTime();

export default {
  name: 'web_customize_lingpao_report_product_sn_craft_parameter_list',
  components: {},
  data() {
    return {
      param: {
        title: 'gongyicanshu',
        visible: false,
        width: '88%'
      },
      craftParameterShow: false,
      exportLoading: false,
      gyHtml: '',
      craftParameters: {},
      equipmentId: undefined,
      conditions: {
        createTimeStart: begin,
        createTimeEnd: end
      },
      columns: [
        {
          label: 'chanpinsn',
          prop: 'productSn'
        },
        {
          label: 'shengchangongdanhao',
          prop: 'sourceWoNo'
        },
        {
          label: 'shebeiSN',
          prop: 'sourceEquipmentSn'
        },
        {
          label: 'shebeimingcheng',
          prop: 'equipment.name'
        },
        {
          label: 'damashijianchuo',
          prop: 'printTime'
        },
        {
          label: 'damashebeihao',
          prop: 'printDeviceSn'
        },
        {
          label: 'mociliushuihao',
          prop: 'mouldSerialNum'
        },
        {
          label: 'riqizifuchuan',
          prop: 'timeString'
        },
        {
          label: 'chuangjianshijian',
          prop: 'createTime',
          type: 'time'
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 150,
          fixed: 'right'
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = this.utils.copy(this.conditions);
      this.yt.get(1);
    }, 300);
  },
  methods: {
    // 查看工艺参数
    getCraftParameter(row) {
      this.$set(row, 'getCraftParameterLoading', true);
      this.equipmentId = row.equipmentId;
      this.http
        .get('/custom/lingpao/product/sn/craft/parameter/getCraftParameter?id=' + row.id)
        .then(res => {
          const data = res.data;
          if (data.craftParameters === undefined || data.craftParameters === null) {
            this.$message.warning(this.$t('meiyougongyicanshu'));
            return;
          }
          if (data.table === undefined || data.table === null) {
            this.$message.warning(this.$t('qingpeizhimuban'));
            return;
          }
          this.param.visible = true;
          this.gyHtml = data.table.gy;
          this.craftParameters = data.craftParameters;
        })
        .catch(err => {
          this.$message.error(this.$t(err));
        })
        .finally(() => {
          this.$set(row, 'getCraftParameterLoading', false);
        });
    },

    // 导出Excel
    exportExcel() {
      this.exportLoading = true;
      let params = this.yt.conditions;
      this.http
        .get('/web/report/export/lingpao_product_sn_craft_parameter_export', {
          params
        })
        .then(res => {
          this.$message.success(this.$t(res.msg));
          this.utils.event_hub.$emit('SHOW_HEADER_EXPORT_DIALOG');
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        })
        .finally(() => {
          this.exportLoading = false;
        });
    },
    // 导出图片
    exportPic() {
      html2canvas(document.getElementById('export')).then(canvas => {
        let dataURL = canvas.toDataURL('image/png');
        if (dataURL !== '') {
          var a = document.createElement('a');
          a.download = this.$t('gongyicanshu');
          a.href = dataURL;
          a.click();
        }
      });
    },
    //导出pdf
    exportPdf() {
      html2canvas(document.getElementById('export')).then(canvas => {
        const doc = new jsPDF('landscape');
        doc.addImage(canvas.toDataURL('image/png'), 'PNG', 10, 10, 280, 180);
        doc.save('工艺参数.pdf');
      });
    }
  },
  computed: {
    gy() {
      try {
        let str = this.gyHtml;
        str = this.base64.decode(str);
        let reg1 = /\[[^\]]*\]/g;
        str.match(reg1) &&
          str.match(reg1).map(code => {
            let c = code.replace('[', '');
            c = c.replace(']', '');
            str = str.replace(code, this.$t(c));
          });

        let reg2 = /\{[^\}]*\}/g;
        str.match(reg2) &&
          str.match(reg2).map(code => {
            let c = code.replace('{', '');
            c = c.replace('}', '');
            if (!this.store.state.eqPoints[this.equipmentId][c]) {
              console.log('工艺模板缺少点' + ':' + c);
              return;
            }
            let prec = this.store.state.eqPoints[this.equipmentId][c].prec;

            if (this.store.state.eqPoints[this.equipmentId][c].dictTypeCode != null) {
              str = str.replace(code, this.$t(this.store.state.dictJsonAll[this.store.state.eqPoints[this.equipmentId][c].dictTypeCode][parseInt(this.craftParameters[c])]));
            } else {
              str = str.replace(code, isNaN(Number(this.craftParameters[c]).toFixed(prec == null ? 2 : prec)) ? '' : Number(this.craftParameters[c]).toFixed(prec == null ? 2 : prec));
            }
          });

        return str;
      } catch (error) {
        console.error(error);
      }
    }
  }
};
</script>
